import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=2217f11b&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=2217f11b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217f11b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2217f11b')) {
      api.createRecord('2217f11b', component.options)
    } else {
      api.reload('2217f11b', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=2217f11b&scoped=true&", function () {
      api.rerender('2217f11b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HtzPjW1EL9Ne/JS/teamMember.vue"
export default component.exports